import { useQuery } from "@tanstack/react-query";
import { getFeeds } from "../../sevices/apiHistory";

export function useFeeds(id, page, pageSize, filters = {}) {
  const {
    isLoading,
    isFetching,
    data: feeds,
    error,
    isError,
  } = useQuery({
    queryKey: [`feeds`, id, page, pageSize, filters],
    queryFn: () => getFeeds(id, page, pageSize, filters),
  });

  return { isLoading, isFetching, error, feeds, isError };
}
